module.exports = __webpack_public_path__ + "static/media/2.bd5f7dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/special/2.png
// module id = 1109
// module chunks = 0